import { useCallback } from 'react';
import { useHistory } from 'react-router-dom';
import { DatalayerLinkTypes } from '../datalayer/App.datalayer.constants';

export const useMapButtonLinkToProps = () => {
  const history = useHistory();

  const mapButtonLinkToProps = useCallback(
    (link?: LinkType, onClickCallback?: (e: any) => void) => {
      if (!link || !link.href) return {};

      return {
        onClick: (event: any) => {
          event.preventDefault();
          if (onClickCallback) {
            onClickCallback(event);
          }
          history.push(link.href as string);
        },
        'data-datalayer-cta-type': 'internal_link',
        'data-datalayer-link-type': DatalayerLinkTypes.CTA,
        'data-datalayer-link': true,
        'data-datalayer-link-href': link.href,
      };
    },
    [history],
  );

  return { mapButtonLinkToProps };
};
